module.exports = __webpack_public_path__ + "img/videoCover.4aab8232.jpg";